<template>
  <div class="layout switchingOperations">
    <p class="tips1">
      注意：1、运维人员禁止新增、修改、删除、保存供应商数据，只能查询数据。
    </p>
    <p class="tips1"><span style="padding-left:55px;">2、如需切换账号，必须退出或关闭浏览器。</span></p>
    <Form :model="formData" ref="formInline" :label-width="150" @submit.native.prevent style="margin-top:10px;">
      <Row>
        <Col :span="8">
          <FormItem prop="vendorAccount"
                    label="供应商账号："
                    :rules="{required: true, message: '供应商账号不能为空', trigger: 'blur'}"
                    >
              <Input v-model.trim="formData.vendorAccount"></Input>
          </FormItem>
        </Col>
        <Col :span="8">
          <Button type="primary" style="margin-left:20px;" :loading="loading" :disabled="formData.vendorAccount === ''" @click="search">查找</Button>
        </Col>
      </Row>
    </Form>

    <div class="operation-con">
      <h2 class="title">结果</h2>
      <div style="padding-left:100px;">
        <p>供应商账号：{{vendorObj.USERNAME}}</p>
        <p style="margin-top:10px;">供应商名称：{{vendorObj.VENDORNAME}}</p>
      </div>
    </div>
    <div class="operation-container">
      <div style="margin-top:20px;text-align:center; flex: 1;">
        <Button type="primary" :disabled="vendorObj.USERNAME === ''" @click="changeVendorInfo" :loading="loading">切换</Button>
        <Poptip
            confirm
            title="确定是要退出吗?"
            @on-ok="out"
            >
            <Button type="error" style="margin-left:20px;">退出</Button>
        </Poptip>
      </div>
    </div>
    <div class="operation-con">
      <h2 class="title">日志</h2>
      <p v-for="(item, key) in logList" :key="key" class="c1" :style="{color: item.indexOf('退出') > '-1' ? 'blue' : 'red'}">{{item}}</p>
    </div>
    <!-- <Button @click="testBtn">测试按钮</Button> -->
  </div>
</template>
<script>
import axios from 'axios';
import { logoutAccount } from '@/utils/index';

export default {
    name: 'switchingOperations',
    data() {
        return {
            formData: {
                vendorAccount: '',
            },
            vendorObj: {
                USERNAME: '',
                VENDORNAME: '',
            },
            loading: false,
            logList: [],
        };
    },
    methods: {
        getUUID_NUM() {
            return localStorage.getItem('UUID_NUM');
        },
        getSupplierInfo() {
            return sessionStorage.getItem('supplierInfo');
        },
        getUser() {
            return localStorage.getItem('user');
        },
        getVendorCode() {
            return localStorage.getItem('vendorCode');
        },
        out() {
            sessionStorage.removeItem('supplierInfo');
            const uuidNum = this.getUUID_NUM();
            const vendorCode = this.getVendorCode();
            const outFun = () => {
                this.$Modal.success({
                    content: '退出成功',
                });
                this.logList.push(`账号${this.getVendorCode()}退出成功`);
                this.$closeTabExcludeSwitch();
            };
            if (!uuidNum || !vendorCode) {
                outFun();
                return;
            }
            axios.post('/gscint/switchAccountOfOperation/logoutAccount', {
                uuidNum,
                vendorCode,
            })
                .then(() => {
                    outFun();
                });
        },
        changeVendorInfo() {
            if (this.getSupplierInfo()) {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: '请退出当前账号再进行操作',
                });
                return;
            }
            this.loading = true;
            const { VENDORID: switchVendorId, USERNAME: switchVendorCode, VENDORNAME: switchVendorName } = this.vendorObj;
            const { loginName: vendorCode } = JSON.parse(this.getUser());
            axios.post('/gscint/switchAccountOfOperation/insertSwitchAccount', {
                vendorCode,
                switchVendorId,
                switchVendorCode,
                switchVendorName,
            })
                .then((res) => {
                    debugger;
                    const { success, data } = res.data;
                    const { DESCRIPTION, UUID_NUM, SWITCH_VENDOR_CODE, VENDOR_NAME_ALT } = data;
                    if (success) {
                        this.$Modal.success({
                            title: this.$t('common.warn'),
                            content: '切换成功！',
                        });
                        this.logList.push(`切换账号${switchVendorCode}执行成功`);
                        const supplierInfo = JSON.parse(localStorage.getItem('supplierInfo') || {});
                        const user = JSON.parse(this.getUser());
                        Object.assign(supplierInfo, {
                            vendorCode: switchVendorCode.substring(1, 9).toUpperCase(),
                            userName: switchVendorCode,
                            vendorName: switchVendorName,
                            vendorId: switchVendorId,
                            shortName: VENDOR_NAME_ALT,
                        });
                        Object.assign(user, {
                            loginName: switchVendorCode,
                            fullpath: switchVendorName,
                            name: DESCRIPTION,
                            isOperations: true,
                            oldAccount: switchVendorCode,
                        });
                        sessionStorage.setItem('supplierInfo', JSON.stringify(supplierInfo));
                        localStorage.setItem('supplierInfo', JSON.stringify(supplierInfo));
                        localStorage.setItem('user', JSON.stringify(user));
                        localStorage.setItem('UUID_NUM', UUID_NUM);
                        localStorage.setItem('vendorCode', SWITCH_VENDOR_CODE);
                        this.$store.commit('switchUpdateUser', user);
                        this.$store.commit('updateSupplierInfo', supplierInfo);
                        this.$closeTabExcludeSwitch();
                    } else {
                        this.showErrorTips();
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        search() {
            const { vendorAccount: userName } = this.formData;
            this.loading = true;
            axios.get('/gscint/switchAccountOfOperation/findVendorInfo', {
                params: {
                    userName,
                },
            })
                .then((res) => {
                    const { data } = res.data;
                    if (data) {
                        Object.assign(this.vendorObj, data);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleBeforeUnload(event) {
            this.logout();
            event.preventDefault();
            event.returnValue = '';
        },
        /* 运维切换退出登录 */
        logout() {
            logoutAccount();
        },
    },
    destroyed() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    mounted() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
};
</script>
<style lang="less" scoped>
.operation-container{
  display: flex;
  .syncMNP-box{
    margin-top: 20px;
  }
}
.switchingOperations {
  background: #FFF;
  padding: 10px 20px;
  .tips1 {
    font-size: 18px;
    color: red;
    font-weight: bold;
  }
  .c1 {
    color: red;
  }
  .operation-con {
    margin-top: 20px;
    border: 1px solid #CCC;
    padding: 0 20px 10px;
    .title {
      position: relative;
      top: -10px;
      font-size: 12px;
    }
  }
}
</style>